import { UiIcon } from './ui-icon';

/**
 * Icon list and there position compared at an element (eg. some text)
 */
export class IconsCombined {
    iconAfter?: UiIcon[];
    iconBefore?: UiIcon[];

    constructor() {
        this.iconBefore = [];
        this.iconAfter = [];
    }
}
